
import { required } from 'vuelidate/lib/validators'

export default {
  occurrence: {
    content: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/form/resources/validations.js